export default {
  methods: {
    printTable(data, headers, title = 'Print Table') {
      const tableHTML = this.generatePrintableTable(data, headers);
      const printWindow = window.open('', '_blank');
      printWindow.document.write('<html><head><title>Print</title></head><body>');
      printWindow.document.write(`<h1>${title}</h1>`);
      printWindow.document.write(tableHTML);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    },
    generatePrintableTable(data, headers) {
      let tableContent = data.map((row) => {
        return `<tr>
${headers.map(header => `<td>${row[header.field]}</td>`).join('')}
</tr>`;
      }).join('');

      return `<table border="1" cellspacing="0" cellpadding="5">
<thead>
<tr>
  ${headers.map(header => `<th>${header.title}</th>`).join('')}
</tr>
</thead>
<tbody>
${tableContent}
</tbody>
</table>`;
    }
  }
}
